import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { AuthService } from './shared/guard/auth.service';
import { ScreenTitleService } from './shared/services/screen-title.service';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LayoutService } from './shared/services/layout.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'OoraFX';
  colorTheme: string;
  loading = true;
  subscription1: Subscription;
  isLoggedIn = false;
  constructor(
    private layoutService: LayoutService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private screentitle: ScreenTitleService,
    private authService: AuthService,
    private bnIdle: BnNgIdleService
    ) {}
    ngOnInit() {
      this.bnIdle.startWatching(300).subscribe((isTimedOut: boolean) => {
        if (isTimedOut) {
          this.authService.logout();
          this.router.navigate(['/auth/login']);
        }
      });
      this.layoutService.castContentSectionTheme.subscribe(
        theme => (this.colorTheme = theme)
      );
      const appTitle = this.titleService.getTitle();
      this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }
          // tslint:disable-next-line: no-string-literal
          if (child.snapshot.data['title']) {
            // tslint:disable-next-line: no-string-literal
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      ).subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
        this.screentitle.setTitle(ttl);
      });
    }
    ngOnDestroy(): void {
    }
}
